import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import type { TPointExternalVendorNames } from 'utils/getPointExternalVendorNames'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { FlowMeterSettingsModal } from './FlowMeterSettingsModal'

const flowMeterSettingsPermission = 'EDIT_IRRIGATION_FLOW_METER_SETTINGS'

export const FlowMeterSettingsTitleLink = ({
  defaultMinFlowRate,
  defaultMaxFlowRate,
  handleAfterSave,
  name,
  externalVendorNames,
}: {
  defaultMinFlowRate: '' | number
  defaultMaxFlowRate: '' | number
  handleAfterSave: (minFlowRate: number | null, maxFlowRate: number | null) => void
  name: string
  externalVendorNames?: TPointExternalVendorNames
}) => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: flowMeterSettingsPermission })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              flowMeterLimitsSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Set Limits')}
      </ResponsiveMenuItem>
      <FlowMeterSettingsModal
        data-role="modal"
        key="flow-meter-limits"
        defaultMinFlowRate={defaultMinFlowRate}
        defaultMaxFlowRate={defaultMaxFlowRate}
        name={name}
        externalVendorNames={externalVendorNames}
        handleAfterSave={handleAfterSave}
      />
    </>,
  )

  return titleLink
}
